export const BENEFIT_KEYS = ['payment', 'account', 'verification', 'support', 'growth']

export const HERO_ILLUSTRATION = '/assets/hero-illustration.png'

export const STEP_KEYS = ['step1', 'step2', 'step3', 'step4']

export const STATUS_MAP = {
  valid: 'default',
  invalid: 'error',
  already_in_mcn: 'error',
  already_member: 'success',
}

export const DEBOUNCE_DELAY = 300
